<template>
    <div>
        <ejs-button cssClass='e-link' v-if='isAvailable' v-on:click.native='clientBtnClick(clientId)'>{{clientName}}</ejs-button>
        <span v-else>{{clientName}}</span>
    </div>
</template>

<script>
    import Vue from "vue";
    import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
    import router from '../../router/index';

    Vue.use(ButtonPlugin);
    export default {
        name: 'ColumnTemplate',
        data() {
            return {
                data: {}
            }
        },
        methods: {
            clientBtnClick: function (id) {
                router.push({ name: "ClientReports", params: { clientId: id } });
            }
        },
        computed: {
            clientId: function () {
                return this.data.clientId;
            },
            clientName: function () {
                return this.data.clientName;
            },
            isAvailable: function () {
                return this.$store.state.permissions["Permissions.Reports.View"] ? true : false;
            }
        }
    }
</script>

<style scoped>
</style>